import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      valuearray: [],
      options: [],
      formData: {
        id: "",
        title: "",
        method: "",
        listorder: "",
        url: "",
        parentid: 0,
        icon: ''
      },
      formLabelWidth: "80px",
      rules: {
        title: [{
          required: true,
          message: "请输入路由名称",
          trigger: "blur"
        }],
        method: [{
          required: true,
          message: "请选择请求方式",
          trigger: "change"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    format: function format(data) {
      var _this = this;

      // 格式化数据格式
      var res = [];
      data.forEach(function (item) {
        var menu = {
          value: item.id,
          label: item.title
        };

        if (item.son && item.son.length > 0) {
          menu.children = _this.format(item.son);
        }

        res.push(menu);
      });
      return res;
    },
    init: function init(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var queryupUser, query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$api.getAllRouter();

              case 2:
                queryupUser = _context.sent;
                _this2.options = _this2.format(queryupUser.data);

                if (!id) {
                  _context.next = 12;
                  break;
                }

                _context.next = 7;
                return _this2.$api.routerDetails({
                  id: id
                });

              case 7:
                query = _context.sent;
                _this2.formData = query.data.route_info;
                _this2.valuearray = [];
                _this2.valuearray = _this2.queryParent(_this2.options, id);

                if (_this2.formData.route) {
                  _this2.formData.parent_id = _this2.valuearray[_this2.valuearray.length - 1] || 0;
                }

              case 12:
                _this2.copyData();

                _this2.dialogFormVisible = true;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getValue: function getValue(val) {
      this.valuearray = val;

      if (this.valuearray.length > 0) {
        this.formData.parentid = this.valuearray[this.valuearray.length - 1];
      } else {
        this.formData.parentid = 0;
      }
    },
    // 查询父级ID
    queryParent: function queryParent(list, id) {
      if (!list || !id) {
        return "";
      }

      var arr = [];

      var findParent = function findParent(data, nodeId, parentId) {
        for (var i = 0, length = data.length; i < length; i++) {
          var node = data[i];

          if (node.value == nodeId) {
            arr.unshift(nodeId);

            if (nodeId === list[0].value) {
              break;
            }

            findParent(list, parentId);
            break;
          } else {
            if (node.children) {
              findParent(node.children, nodeId, node.value);
            }

            continue;
          }
        }

        return arr;
      };

      return findParent(list, id);
    },
    rewriteClearData: function rewriteClearData() {
      this.valuearray = [];
      this.clearData();
    },
    submitForm: function submitForm() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                reqFn = _this3.formData.id ? 'updataRouter' : 'addRouter';

                _this3.$api[reqFn](_this3.formData).then(function (res) {
                  if (res.status == 200) {
                    _this3.$message.success('操作成功');

                    _this3.$emit("change");

                    _this3.dialogFormVisible = false;
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    deepFind: function deepFind(arr, condition, children) {
      // 即将返回的数组
      var main = []; // 用try方案方便直接中止所有递归的程序

      try {
        // 开始轮询
        (function poll(arr, level) {
          // 如果传入非数组
          if (!Array.isArray(arr)) return; // 遍历数组

          for (var i = 0; i < arr.length; i++) {
            // 获取当前项
            var item = arr[i]; // 先占位预设值

            main[level] = item; // 检验是否已经找到了

            var isFind = condition && condition(item, i, level) || false; // 如果已经找到了

            if (isFind) {
              // 直接抛出错误中断所有轮询
              throw Error; // 如果存在children，那么深入递归
            } else if (children && item[children] && item[children].length) {
              poll(item[children], level + 1); // 如果是最后一个且没有找到值，那么通过修改数组长度来删除当前项
            } else if (i === arr.length - 1) {
              // 删除占位预设值
              main.length = main.length - 1;
            }
          }
        })(arr, 0); // 使用try/catch是为了中止所有轮询中的任务

      } catch (err) {} // 返回最终数组


      return main;
    }
  }
};